// extracted by mini-css-extract-plugin
export default {"entitiesSection":"Entity_entitiesSection__Xa7yj","entityWrapper":"Entity_entityWrapper__1tRw+","innerGroup":"Entity_innerGroup__I+uly"};